




































































import { Component, Vue, Prop } from "vue-property-decorator";
import draggable from "vuedraggable";
import DashCard from "@/components/app/shared/cards/dash-card.vue";
import type { ComplexMenuVariant } from "@/@types/menu/complex-menu";

@Component({ components: { draggable, DashCard } })
class ComplexMenuVariantListCard extends Vue {
  @Prop({ type: Object, default: null }) variant!: ComplexMenuVariant;
  @Prop({ type: Number, default: 0 }) current_variant!: number;

  enabled = true;
  dragging = false;

  setActive(): void {
    this.$emit("setActive", this.variant.variant);
  }
}
export default ComplexMenuVariantListCard;
